module.exports = __webpack_public_path__ + "static/media/coupon.16d1073a.png";